export const settingIcons = {
    moon: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.4"
                d="M16.9462 11.0863C16.9759 11.0875 17.0055 11.0886 17.035 11.0898C20.1966 11.2176 22.5 13.3358 22.5 16.5C22.5 19.6642 20.1966 21.7824 17.035 21.9102C15.7057 21.9639 14.0498 22 12 22C9.9502 22 8.2943 21.9639 6.965 21.9102C3.80337 21.7824 1.5 19.6642 1.5 16.5C1.5 14.0317 2.90165 12.1999 5.019 11.4529C5.2406 8.2951 7.3872 6.02435 10.6413 6.00125C10.7585 6.00045 10.878 6 11 6C11.122 6 11.2415 6.00045 11.3587 6.00125C14.4855 6.02345 16.5897 8.1208 16.9462 11.0863Z"
                fill="currentColor"
            />
            <path
                d="M19.2407 2.28853C19.5263 2.12002 19.5419 1.62921 19.2169 1.57222C18.1306 1.38179 16.9755 1.56344 15.9464 2.17059C14.4123 3.07575 13.5394 4.70186 13.501 6.38837C15.4283 7.12677 16.6785 8.86242 16.9459 11.0863L17.0347 11.0898C17.7391 11.1183 18.401 11.2456 19.0042 11.4612C19.6324 11.3806 20.2555 11.1732 20.8383 10.8294C21.8673 10.2222 22.5988 9.2907 22.9806 8.23415C23.0948 7.918 22.6711 7.6864 22.3855 7.8549C20.8813 8.74235 18.958 8.2157 18.0896 6.6786C17.2212 5.1415 17.7366 3.17599 19.2407 2.28853Z"
                fill="currentColor"
            />
        </svg>
    ),
    contrast: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z"
                fill="currentColor"
            />
            <path
                d="M11.1299 20.6213C9.59086 20.4566 8.12388 19.8832 6.88089 18.9607C5.63791 18.0383 4.66413 16.8002 4.06042 15.3747C4.04526 15.3389 4.03101 15.3029 4.01638 15.2669L11.1299 19.2499V20.6213ZM11.1299 17.7217L3.50026 13.4499C3.42001 12.9712 3.37975 12.4867 3.37988 12.0013C3.37988 11.726 3.39269 11.4527 3.4183 11.1816L11.1299 15.4993V17.7217ZM11.1299 13.9711L3.66401 9.79102C3.76825 9.39432 3.90072 9.00559 4.06042 8.6278C4.13729 8.44591 4.22016 8.26733 4.30905 8.09205L11.1299 11.9153V13.9711ZM11.1299 10.3866L5.0013 6.95138C5.27722 6.56735 5.5839 6.20639 5.9183 5.87205C6.02163 5.76871 6.12719 5.6683 6.23497 5.57084L11.1299 8.25191V10.3866ZM11.1299 6.73156L7.39455 4.68571C8.52175 3.96725 9.80052 3.52071 11.1299 3.38135V6.73156Z"
                fill="currentColor"
            />
        </svg>
    ),
    alignRight: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.4">
                <path
                    d="M8.0351 4.74734C8.06655 3.88857 8.5909 3.23087 9.44555 3.14106C10.1775 3.06415 11.2981 3 13 3C14.7019 3 15.8225 3.06415 16.5545 3.14106C17.4091 3.23087 17.9334 3.88857 17.9649 4.74734C17.9847 5.28845 18 6.0223 18 7C18 7.9777 17.9847 8.71155 17.9649 9.25265C17.9334 10.1115 17.4091 10.7691 16.5545 10.8589C15.8225 10.9358 14.7019 11 13 11C11.2981 11 10.1775 10.9358 9.44555 10.8589C8.5909 10.7691 8.06655 10.1115 8.0351 9.25265C8.01525 8.71155 8 7.9777 8 7C8 6.0223 8.01525 5.28845 8.0351 4.74734Z"
                    fill="currentColor"
                />
                <path
                    d="M2.04635 14.9249C2.0959 13.9629 2.75505 13.2665 3.71495 13.1855C4.8412 13.0906 6.76375 13 10 13C13.2362 13 15.1588 13.0906 16.2851 13.1855C17.245 13.2665 17.9041 13.9629 17.9536 14.9249C17.9805 15.4458 18 16.1253 18 17C18 17.8747 17.9805 18.5542 17.9536 19.0751C17.9041 20.0371 17.245 20.7335 16.2851 20.8144C15.1588 20.9094 13.2362 21 10 21C6.76375 21 4.8412 20.9094 3.71495 20.8144C2.75505 20.7335 2.0959 20.0371 2.04635 19.0751C2.0195 18.5542 2 17.8747 2 17C2 16.1253 2.0195 15.4458 2.04635 14.9249Z"
                    fill="currentColor"
                />
            </g>
            <path
                d="M20.9641 2.0252C20.4224 2.0806 20.1307 2.55551 20.1106 3.09972C20.0661 4.30253 20 6.94185 20 12C20 17.0581 20.0661 19.6974 20.1106 20.9003C20.1307 21.4445 20.4224 21.9194 20.9641 21.9748C21.116 21.9904 21.2935 22 21.5 22C21.7065 22 21.884 21.9904 22.0359 21.9748C22.5776 21.9194 22.8693 21.4445 22.8894 20.9003C22.9339 19.6974 23 17.0581 23 12C23 6.94185 22.9339 4.30253 22.8894 3.09972C22.8693 2.55551 22.5776 2.0806 22.0359 2.0252C21.884 2.00967 21.7065 2 21.5 2C21.2935 2 21.116 2.00967 20.9641 2.0252Z"
                fill="currentColor"
            />
        </svg>
    ),
    autofitWidth: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.4"
                d="M21 5.66667C21 4.95942 20.7037 4.28115 20.1762 3.78105C19.6488 3.28095 18.9334 3 18.1875 3H5.8125C5.06658 3 4.35121 3.28095 3.82376 3.78105C3.29632 4.28115 3 4.95942 3 5.66667V9.93333C3 10.2162 3.11853 10.4875 3.32951 10.6876C3.54048 10.8876 3.82663 11 4.125 11C4.42337 11 4.70952 10.8876 4.9205 10.6876C5.13147 10.4875 5.25 10.2162 5.25 9.93333V5.66667C5.25 5.52522 5.30926 5.38956 5.41475 5.28954C5.52024 5.18952 5.66332 5.13333 5.8125 5.13333H18.1875C18.3367 5.13333 18.4798 5.18952 18.5852 5.28954C18.6907 5.38956 18.75 5.52522 18.75 5.66667V9.93333C18.75 10.2162 18.8685 10.4875 19.0795 10.6876C19.2905 10.8876 19.5766 11 19.875 11C20.1734 11 20.4595 10.8876 20.6705 10.6876C20.8815 10.4875 21 10.2162 21 9.93333V5.66667Z"
                fill="currentColor"
            />
            <path
                d="M18.8972 20.6792L21.6747 17.822C21.883 17.6077 22 17.3171 22 17.014C22 16.711 21.883 16.4204 21.6747 16.206L18.8972 13.3489C18.6889 13.1345 18.4062 13.0139 18.1115 13.0138C17.8168 13.0137 17.5341 13.134 17.3256 13.3483C17.1172 13.5626 17 13.8533 16.9999 14.1565C16.9998 14.4597 17.1168 14.7505 17.3251 14.9649L19.3171 17.014L17.3251 19.0632C17.1227 19.2787 17.0107 19.5674 17.0133 19.8671C17.0158 20.1667 17.1326 20.4534 17.3386 20.6653C17.5446 20.8772 17.8233 20.9974 18.1146 21C18.4059 21.0026 18.6876 20.8874 18.8972 20.6792ZM2.32529 16.206C2.11701 16.4204 2 16.711 2 17.014C2 17.3171 2.11701 17.6077 2.32529 17.822L5.10283 20.6792C5.31236 20.8874 5.59301 21.0026 5.88431 21C6.17562 20.9974 6.45427 20.8772 6.66027 20.6653C6.86626 20.4534 6.9831 20.1667 6.98563 19.8671C6.98816 19.5674 6.87618 19.2787 6.6738 19.0632L4.68286 17.014L6.67491 14.9649C6.78102 14.8595 6.86566 14.7334 6.92389 14.5939C6.98212 14.4545 7.01277 14.3045 7.01405 14.1528C7.01533 14.001 6.98722 13.8505 6.93136 13.7101C6.87549 13.5696 6.793 13.442 6.68868 13.3347C6.58436 13.2274 6.46032 13.1426 6.32378 13.0851C6.18724 13.0276 6.04094 12.9987 5.89342 13C5.7459 13.0014 5.60011 13.0329 5.46457 13.0928C5.32902 13.1527 5.20642 13.2397 5.10394 13.3489L2.32529 16.206ZM13.111 17.014C13.111 16.7109 12.994 16.4202 12.7856 16.2059C12.5773 15.9916 12.2947 15.8712 12 15.8712C11.7053 15.8712 11.4228 15.9916 11.2144 16.2059C11.006 16.4202 10.889 16.7109 10.889 17.014C10.889 17.3171 11.006 17.6078 11.2144 17.8222C11.4228 18.0365 11.7053 18.1569 12 18.1569C12.2947 18.1569 12.5773 18.0365 12.7856 17.8222C12.994 17.6078 13.111 17.3171 13.111 17.014ZM8.66696 15.8712C8.96162 15.8712 9.24421 15.9916 9.45256 16.2059C9.66092 16.4202 9.77797 16.7109 9.77797 17.014C9.77797 17.3171 9.66092 17.6078 9.45256 17.8222C9.24421 18.0365 8.96162 18.1569 8.66696 18.1569H7.55594C7.26129 18.1569 6.97869 18.0365 6.77034 17.8222C6.56198 17.6078 6.44493 17.3171 6.44493 17.014C6.44493 16.7109 6.56198 16.4202 6.77034 16.2059C6.97869 15.9916 7.26129 15.8712 7.55594 15.8712H8.66696ZM17.5551 17.014C17.5551 16.7109 17.438 16.4202 17.2297 16.2059C17.0213 15.9916 16.7387 15.8712 16.4441 15.8712H15.333C15.0384 15.8712 14.7558 15.9916 14.5474 16.2059C14.3391 16.4202 14.222 16.7109 14.222 17.014C14.222 17.3171 14.3391 17.6078 14.5474 17.8222C14.7558 18.0365 15.0384 18.1569 15.333 18.1569H16.4441C16.7387 18.1569 17.0213 18.0365 17.2297 17.8222C17.438 17.6078 17.5551 17.3171 17.5551 17.014Z"
                fill="currentColor"
            />
        </svg>
    ),
    navVertical: (
        <svg
            width="86"
            height="64"
            viewBox="0 0 86 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1153_603)">
                <mask id="path-2-inside-1_1153_603" fill="white">
                    <path d="M0 0H32V64H0V0Z" />
                </mask>
                <path
                    d="M31 0V64H33V0H31Z"
                    fill="currentColor"
                    fillOpacity="0.08"
                    mask="url(#path-2-inside-1_1153_603)"
                />
                <circle opacity="0.8" cx="11" cy="11" r="5" fill="currentColor" />
                <rect
                    opacity="0.48"
                    x="6"
                    y="20"
                    width="20"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.24"
                    x="6"
                    y="28"
                    width="14"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.2"
                    x="36"
                    y="4"
                    width="46"
                    height="56"
                    rx="8"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1153_603">
                    <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H74C80.6274 0 86 5.37258 86 12V52C86 58.6274 80.6274 64 74 64H12C5.37258 64 0 58.6274 0 52V12Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    navHorizontal: (
        <svg
            width="86"
            height="64"
            viewBox="0 0 86 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1153_596)">
                <mask id="path-2-inside-1_1153_596" fill="white">
                    <path d="M0 0H86V22H0V0Z" />
                </mask>
                <path
                    d="M86 21H0V23H86V21Z"
                    fill="currentColor"
                    fillOpacity="0.08"
                    mask="url(#path-2-inside-1_1153_596)"
                />
                <circle opacity="0.8" cx="11" cy="11" r="5" fill="currentColor" />
                <rect
                    opacity="0.48"
                    x="20"
                    y="9"
                    width="16"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.24"
                    x="40"
                    y="9"
                    width="10"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.2"
                    x="4"
                    y="26"
                    width="78"
                    height="34"
                    rx="8"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1153_596">
                    <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H74C80.6274 0 86 5.37258 86 12V52C86 58.6274 80.6274 64 74 64H12C5.37258 64 0 58.6274 0 52V12Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    navMini: (
        <svg
            width="86"
            height="64"
            viewBox="0 0 86 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1153_589)">
                <mask id="path-2-inside-1_1153_589" fill="white">
                    <path d="M0 0H22V64H0V0Z" />
                </mask>
                <path
                    d="M21 0V64H23V0H21Z"
                    fill="currentColor"
                    fillOpacity="0.08"
                    mask="url(#path-2-inside-1_1153_589)"
                />
                <circle opacity="0.8" cx="11" cy="11" r="5" fill="currentColor" />
                <rect
                    opacity="0.48"
                    x="6"
                    y="20"
                    width="10"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.24"
                    x="6"
                    y="28"
                    width="10"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    opacity="0.2"
                    x="26"
                    y="4"
                    width="56"
                    height="56"
                    rx="8"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1153_589">
                    <path
                        d="M0 12C0 5.37258 5.37258 0 12 0H74C80.6274 0 86 5.37258 86 12V52C86 58.6274 80.6274 64 74 64H12C5.37258 64 0 58.6274 0 52V12Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    sidebarOutline: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.557 2.25C16.395 2.25 17.851 2.25 18.99 2.403C20.162 2.561 21.111 2.893 21.86 3.641C22.608 4.39 22.94 5.339 23.098 6.511C23.251 7.651 23.251 9.106 23.251 10.944V13.056C23.251 14.894 23.251 16.35 23.098 17.489C22.94 18.661 22.608 19.61 21.86 20.359C21.111 21.107 20.162 21.439 18.99 21.597C17.85 21.75 16.395 21.75 14.557 21.75H9.53498C9.51097 21.7508 9.48695 21.7505 9.46298 21.749C8.07898 21.745 6.93998 21.722 6.01198 21.597C4.83998 21.439 3.89098 21.107 3.14198 20.359C2.39398 19.61 2.06198 18.661 1.90398 17.489C1.75098 16.349 1.75098 14.894 1.75098 13.056V10.944C1.75098 9.106 1.75098 7.65 1.90398 6.511C2.06198 5.339 2.39398 4.39 3.14198 3.641C3.89098 2.893 4.83998 2.561 6.01198 2.403C6.93998 2.278 8.07898 2.255 9.46198 2.251C9.4863 2.24984 9.51066 2.24984 9.53498 2.251L10.445 2.25H14.557ZM10.251 3.75H14.501C16.408 3.75 17.762 3.752 18.791 3.89C19.796 4.025 20.376 4.279 20.799 4.702C21.222 5.125 21.476 5.705 21.611 6.711C21.749 7.739 21.751 9.093 21.751 11V13C21.751 14.907 21.749 16.262 21.611 17.29C21.476 18.295 21.222 18.875 20.799 19.298C20.376 19.721 19.796 19.975 18.79 20.11C17.762 20.248 16.408 20.25 14.501 20.25H10.251V3.75ZM8.75098 20.244C7.71698 20.234 6.89298 20.202 6.21098 20.11C5.20598 19.975 4.62598 19.721 4.20298 19.298C3.77998 18.875 3.52598 18.295 3.39098 17.289C3.25298 16.262 3.25098 14.907 3.25098 13V11C3.25098 9.093 3.25298 7.739 3.39098 6.71C3.52598 5.705 3.77998 5.125 4.20298 4.702C4.62598 4.279 5.20598 4.025 6.21198 3.89C6.89198 3.798 7.71698 3.767 8.75098 3.756V20.244Z"
                fill="currentColor"
            />
            <path
                d="M4.49991 9C4.49991 8.58579 4.8357 8.25 5.24991 8.25H6.74991C7.16412 8.25 7.49991 8.58579 7.49991 9C7.49991 9.41421 7.16412 9.75 6.74991 9.75H5.24991C4.8357 9.75 4.49991 9.41421 4.49991 9Z"
                fill="currentColor"
            />
            <path
                d="M4.49991 12C4.49991 11.5858 4.8357 11.25 5.24991 11.25H6.74991C7.16412 11.25 7.49991 11.5858 7.49991 12C7.49991 12.4142 7.16412 12.75 6.74991 12.75H5.24991C4.8357 12.75 4.49991 12.4142 4.49991 12Z"
                fill="currentColor"
            />
            <path
                d="M4.49991 15C4.49991 14.5858 4.8357 14.25 5.24991 14.25H6.74991C7.16412 14.25 7.49991 14.5858 7.49991 15C7.49991 15.4142 7.16412 15.75 6.74991 15.75H5.24991C4.8357 15.75 4.49991 15.4142 4.49991 15Z"
                fill="currentColor"
            />
        </svg>
    ),
    sidebarFill: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.99 2.403C17.851 2.25 16.395 2.25 14.557 2.25H10.445L9.53498 2.251C9.51066 2.24984 9.4863 2.24984 9.46198 2.251C8.07898 2.255 6.93998 2.278 6.01198 2.403C4.83998 2.561 3.89098 2.893 3.14198 3.641C2.39398 4.39 2.06198 5.339 1.90398 6.511C1.75098 7.65 1.75098 9.106 1.75098 10.944V13.056C1.75098 14.894 1.75098 16.349 1.90398 17.489C2.06198 18.661 2.39398 19.61 3.14198 20.359C3.89098 21.107 4.83998 21.439 6.01198 21.597C6.93998 21.722 8.07898 21.745 9.46298 21.749C9.48695 21.7505 9.51097 21.7508 9.53498 21.75H14.557C16.395 21.75 17.85 21.75 18.99 21.597C20.162 21.439 21.111 21.107 21.86 20.359C22.608 19.61 22.94 18.661 23.098 17.489C23.251 16.35 23.251 14.894 23.251 13.056V10.944C23.251 9.106 23.251 7.651 23.098 6.511C22.94 5.339 22.608 4.39 21.86 3.641C21.111 2.893 20.162 2.561 18.99 2.403ZM14.501 3.75H10.251V20.25H14.501C16.408 20.25 17.762 20.248 18.79 20.11C19.796 19.975 20.376 19.721 20.799 19.298C21.222 18.875 21.476 18.295 21.611 17.29C21.749 16.262 21.751 14.907 21.751 13V11C21.751 9.093 21.749 7.739 21.611 6.711C21.476 5.705 21.222 5.125 20.799 4.702C20.376 4.279 19.796 4.025 18.791 3.89C17.762 3.752 16.408 3.75 14.501 3.75ZM4.49993 9C4.49993 8.58579 4.83571 8.25 5.24993 8.25H6.74993C7.16414 8.25 7.49993 8.58579 7.49993 9C7.49993 9.41421 7.16414 9.75 6.74993 9.75H5.24993C4.83571 9.75 4.49993 9.41421 4.49993 9ZM4.49993 12C4.49993 11.5858 4.83571 11.25 5.24993 11.25H6.74993C7.16414 11.25 7.49993 11.5858 7.49993 12C7.49993 12.4142 7.16414 12.75 6.74993 12.75H5.24993C4.83571 12.75 4.49993 12.4142 4.49993 12ZM5.24993 14.25C4.83571 14.25 4.49993 14.5858 4.49993 15C4.49993 15.4142 4.83571 15.75 5.24993 15.75H6.74993C7.16414 15.75 7.49993 15.4142 7.49993 15C7.49993 14.5858 7.16414 14.25 6.74993 14.25H5.24993Z"
                fill="currentColor"
            />
        </svg>
    ),
    siderbarDuotone: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.828 4.172C22 5.343 22 7.229 22 11V13C22 16.771 22 18.657 20.828 19.828C19.657 21 17.771 21 14 21H9V3H14C17.771 3 19.657 3 20.828 4.172Z"
                fill="currentColor"
            />
            <path
                d="M18.5 9.244C18.6989 9.244 18.8897 9.32302 19.0303 9.46367C19.171 9.60432 19.25 9.79509 19.25 9.994C19.25 10.1929 19.171 10.3837 19.0303 10.5243C18.8897 10.665 18.6989 10.744 18.5 10.744H12.5C12.3011 10.744 12.1103 10.665 11.9697 10.5243C11.829 10.3837 11.75 10.1929 11.75 9.994C11.75 9.79509 11.829 9.60432 11.9697 9.46367C12.1103 9.32302 12.3011 9.244 12.5 9.244H18.5ZM17.5 13.244C17.6989 13.244 17.8897 13.323 18.0303 13.4637C18.171 13.6043 18.25 13.7951 18.25 13.994C18.25 14.1929 18.171 14.3837 18.0303 14.5243C17.8897 14.665 17.6989 14.744 17.5 14.744H13.5C13.3011 14.744 13.1103 14.665 12.9697 14.5243C12.829 14.3837 12.75 14.1929 12.75 13.994C12.75 13.7951 12.829 13.6043 12.9697 13.4637C13.1103 13.323 13.3011 13.244 13.5 13.244H17.5ZM2 12.994V10.994C2 7.223 2 5.337 3.172 4.166C4.146 3.191 6.364 3.027 9 3V20.988C6.364 20.961 4.146 20.797 3.172 19.822C2 18.651 2 16.765 2 12.994Z"
                fill="currentColor"
            />
        </svg>
    ),
    font: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.4"
                d="M17.1229 18.16C16.5754 18.16 16.0833 18.0577 15.6464 17.8531C15.2096 17.6485 14.864 17.3526 14.6096 16.9656C14.3552 16.5729 14.228 16.0974 14.228 15.5389C14.228 14.5988 14.5792 13.8855 15.2814 13.3989C15.9837 12.9067 17.0924 12.6523 18.6076 12.6357L19.6776 12.6192V12.1049C19.6776 11.7123 19.5615 11.4109 19.3292 11.2008C19.1025 10.9851 18.7486 10.88 18.2675 10.8856C17.9136 10.8911 17.5763 10.974 17.2556 11.1344C16.9404 11.2948 16.7247 11.574 16.6086 11.9722H14.593C14.6262 11.3528 14.8059 10.8441 15.1321 10.446C15.4584 10.0423 15.9008 9.74368 16.4593 9.55013C17.0233 9.35106 17.662 9.25153 18.3754 9.25153C19.2546 9.25153 19.9596 9.36212 20.4905 9.58331C21.0214 9.79897 21.4057 10.1114 21.6435 10.5206C21.8812 10.9243 22.0001 11.4054 22.0001 11.9639V17.9941H19.9762L19.7772 16.5176C19.4841 17.137 19.1163 17.5655 18.674 17.8033C18.2371 18.0411 17.7201 18.16 17.1229 18.16ZM17.9357 16.5674C18.1569 16.5674 18.3698 16.5287 18.5744 16.4513C18.7846 16.3683 18.9698 16.2605 19.1302 16.1278C19.2961 15.9896 19.4288 15.8347 19.5283 15.6633C19.6278 15.4919 19.6776 15.3149 19.6776 15.1324V13.8634L18.8067 13.8799C18.403 13.8855 18.027 13.9352 17.6786 14.0292C17.3302 14.1177 17.0482 14.2643 16.8326 14.4689C16.6224 14.6735 16.5174 14.95 16.5174 15.2983C16.5174 15.6965 16.6556 16.0089 16.9321 16.2356C17.2086 16.4568 17.5431 16.5674 17.9357 16.5674Z"
                fill="currentColor"
            />
            <path
                d="M2 17.9941L6.29663 6H8.85139L13.1397 17.9941H10.726L9.74721 15.2154H5.43399L4.43033 17.9941H2ZM5.97314 13.1002H9.16658L7.5823 8.33909L5.97314 13.1002Z"
                fill="currentColor"
            />
        </svg>
    ),
};
